<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :meun="meunItem" :title="meunTitle" :title2="headTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <h3 class="title">{{ headTitle }}</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <div class="input_div">
                <p>排序</p>
                <el-input class="input" type="number" @keyup.native="proving(3)" v-model="info.order" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>商品名称</p>
                <el-input class="input" v-model="info.title" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>价格</p>
                <el-input class="input" type="number" @keyup.native="proving(0)" v-model="info.price" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>库存总数</p>
                <el-input class="input" type="number" @keyup.native="proving(1)" v-model="info.stock" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>商品状态</p>
                <el-select style="width: 100%" v-model="info.status" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in statusOptions" :key="item.value" :value="item.value" :label="item.text"></el-option>
                </el-select>
              </div>
              <div class="input_div">
                <p>发货方式</p>
                <el-input class="input" v-model="info.distribution" placeholder="请输入" :disabled="true"></el-input>
              </div>
              <div class="input_div">
                <p>发货时效</p>
                <el-input class="input" type="number" @keyup.native="proving(2)" v-model="info.delivery" placeholder="请输入"></el-input>
              </div>
              <div class="input_div">
                <p>是否推送</p>
                <el-select class="input" v-model="info.is_push" placeholder="请选择" collapse-tags>
                  <el-option v-for="item in pushOptions" :key="item.en" :value="item.en" :label="item.cn"></el-option>
                </el-select>
              </div>
              <div style="clear: both"></div>
              <div style="clear: both"></div>
              <div class="input_div" style="width: 100%" ref="_elCard">
                <p>上传宣传图（最多5张）</p>
                <input type="file" accept="image/*" style="display: none" id="uploadfile" @change="openFolder" />
                <div class="imageDivBox" v-for="(item, index) in shopImage" :key="index">
                  <el-image fit="contain" class="imageDiv" :src="item">
                    <div slot="error" class="image-slot" style="position: absolute; top: 50%; left: 50%">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <i v-show="item != ''" class="el-icon-circle-close" style="float: right; cursor: pointer" @click="delImage(item, index)"></i>
                </div>
                <div style="clear: both"></div>
                <el-button v-show="shopImage.length < 5" size="mini" @click="openImage()">新增宣传图</el-button>
              </div>
              <div style="clear: both"></div>
              <div class="input_div" style="width: 100%">
                <p>详情</p>
                <VueUeditorWrap :destroy="true" v-model="info.details" :config="editorConfig" />
                <!-- <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="info.details"> </el-input> -->
              </div>
            </div>
          </div>
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { URL_PATH, Editor_Config } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import Coordinates from '@/components/layout/Coordinates'
import FootLayout from '@/components/layout/footLayout'
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout,
    Coordinates,
    VueUeditorWrap
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      headTitle: '',
      urlPath: URL_PATH,
      info: { order: 10000, distribution: '到付', is_push: 'N', details: '' },
      pushOptions: Constant.options_yesorno, //是否推送
      statusOptions: Constant.options_state_product,
      shopImage: [''],
      coordinatesInfo: {},
      editorConfig: Editor_Config
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.infoId = this.$route.query.id
      this.headTitle = this.infoId == null ? '添加商品' : '编辑商品'
      this.getInfo()
    },
    // 获取详情
    getInfo() {
      var id = this.$route.query.id
      if (id == null) return
      this.$api
        .integralProductInfo({
          token: localStorage.getItem('token'),
          product_id: id
        })
        .then(({ data }) => {
          this.info = data.Data
          this.createTime = new Date(this.info.create_time * 1000)
          if (this.info.thumb.length > 0) this.shopImage = []
          this.info.thumb.forEach(image => {
            this.shopImage.push(this.urlPath + image)
          })
        })
        .catch(({ error }) => {})
    },
    // 新增
    addInfo: function (form) {
      this.$api
        .updateIntegralProduct(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 编辑
    updateInfo: function (form) {
      form.append('product_id', this.info.id)
      this.$api
        .updateIntegralProduct(form)
        .then(({ data }) => {
          this.$router.back(-1)
        })
        .catch(({ error }) => {})
    },
    // 选择图片
    openImage() {
      document.getElementById('uploadfile').click()
    },
    openFolder(e) {
      var image = e.target.files[0]
      // 宣传图 去上传图片 返回图片url
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('image', image)
      this.$api
        .uploadProductThumb(form)
        .then(({ data }) => {
          if (this.shopImage[0] == '') this.shopImage = []
          this.shopImage.push(this.urlPath + data.Data.link)
          console.log(this.shopImage)
        })
        .catch(({ error }) => {})
    },
    // 删除图片
    delImage(item, index) {
      if (item == '') return
      this.$confirm('是否删除此宣传图?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.shopImage.splice(index, 1)
          if (this.shopImage.length == 0) this.shopImage.push('')
        })
        .catch(() => {})
    },
    proving(index) {
      switch (index) {
        case 0:
          // this.info.price=this.info.price.replace(/[^\d\.]/g,'')
          this.info.price = this.info.price.replace(/\D/g, '')
          break
        case 1:
          this.info.stock = this.info.stock.replace(/\D/g, '')
          break
        case 2:
          this.info.delivery = this.info.delivery.replace(/\D/g, '')
          break
        case 3:
          this.info.order = this.info.order.replace(/\D/g, '')
          break
      }
    },
    // 保存
    saveEdit() {
      if (
        StrUtils.isEmpty(this.info.order) ||
        StrUtils.isEmpty(this.info.title) ||
        StrUtils.isEmpty(this.info.stock) ||
        StrUtils.isEmpty(this.info.price) ||
        StrUtils.isEmpty(this.info.distribution) ||
        StrUtils.isEmpty(this.info.delivery) ||
        StrUtils.isEmpty(this.info.details) ||
        StrUtils.isEmpty(this.info.status) ||
        (this.shopImage.length <= 1 && this.shopImage[0] == '')
      ) {
        this.$message.error('请先完善数据')
        return
      }
      if (this.info.price > 10000 * 100) {
        this.$message.error('价格不能超过100万')
        return
      }
      if (this.info.stock < 0) {
        this.$message.error('库存总数不能少于0')
        return
      }
      if (this.info.stock > 10000 * 10) {
        this.$message.error('库存总数不能超过10万')
        return
      }
      var shopImages = []
      this.shopImage.forEach(image => {
        shopImages.push(image.substring(this.urlPath.length, image.length))
      })
      var form = new FormData()
      form.append('token', localStorage.getItem('token'))
      form.append('title', this.info.title)
      form.append('thumb', JSON.stringify(shopImages))
      form.append('stock', this.info.stock)
      form.append('price', this.info.price)
      form.append('distribution', this.info.distribution)
      form.append('delivery', this.info.delivery)
      form.append('details', this.info.details)
      form.append('status', this.info.status)
      form.append('order', this.info.order)
      form.append('is_push', this.info.is_push)
      if (this.infoId) {
        this.updateInfo(form)
      } else {
        this.addInfo(form)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
.imageDivBox {
  float: left;
  overflow: hidden;
  width: 370px;
  height: 254px;
}
</style>

 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 290px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/integralProductAdd.vue